<app-client-info></app-client-info>
<app-case-pdf-info></app-case-pdf-info>

<app-table [sortOptions]="this.sortOptions" (parentFunc)="table1rowFunc($event)" [sizeOptions]="sizeOptions" [Title]="Title" [Collection]="this.submittedCaseCollection" [displayedColumns]="displayedColumns"></app-table>
